<template>
  <article class="">
    <cabecera></cabecera>
      <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Gobierno Corporativo</h2>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="caja">
          <h5>Gobierno corporativo</h5>
          <p>En COMPAÑÍA MEGA priorizamos y alentamos la incorporación de las mejores prácticas de Gobierno Corporativo, porque estamos convencidos de que éstas, son herramientas clave para coadyuvar a la seguridad económica y jurídica, tanto de los inversores, como de la Compañía, de sus accionistas, empleados y de la sociedad en general, adicionando transparencia e integridad a nuestra gestión.
          <br><br>
            Actualmente, las prácticas de Gobierno Corporativo de COMPAÑÍA MEGA están reguladas por el Estatuto de la Compañía, el Código de Ética, las Políticas Internas, la Ley General de Sociedades N° 19.550, la Ley de Mercado de Capitales N°26.831, las normas de la Comisión Nacional de Valores, y las demás normas del ordenamiento legal vigente que resultan de aplicación.

            </p>
        <!--     <h5 style="margin-top: 20px">Código de Ética</h5>
          <p>
          Nuestro Código de Ética tiene como finalidad establecer las directrices que deben regir la conducta de todos los miembros de la Compañía en el cumplimiento de sus funciones laborales, relaciones comerciales, operativas y vínculos profesionales. Aplica tanto a los miembros del Directorio, de la Comisión Fiscalizadora, Gerentes, empleados, como a todos los proveedores, contratistas, subcontratistas y socios de negocios de la Compañía.<br><br>

          <a target="_blank" href="static/pdf/codigo-de-etica-compania-mega.pdf">Descarga el código de ética <i class="icon-file-pdf"></i></a>
          </p> -->
            
        </div>
      </div>
      
    </section>
     <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p>La Línea Ética de Compañía Mega S.A. es una herramienta diseñada para facilitar la denuncia de conductas contrarias al Código de Ética. La misma se encuentra disponible todos los días, las 24 hs. y es administrada por la firma BDO, tercero independiente que garantiza la confidencialidad, anonimato y transparencia del sistema de recepción de denuncias.</p>
           
            <img src="./linea-etica.jpg" alt="Banner de las plantas de Mega Cia." class="img-fluid">
          </div>
        </div>
      </div>
    </section>
    <section class="secundario">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <h4>Canales de Denuncia</h4>
            <ul>
              <li>Teléfono: 0800-34-LINEA (54632)</li>
              <li>Página web: <a href="http://www.bdolineaetica.com/ciamega" target="_blank">www.bdolineaetica.com/ciamega</a></li>
              <li>Email: <a href="mailto:ciamega@bdolineaetica.com">ciamega@bdolineaetica.com</a></li>
              <li>Carta: Rondeau 2664 PB, C1262ABH CABA</li>
              <li>Entrevista personal: Maipú 942 PB, C1006ACN CABA</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="descargas">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8"> 
            <a href="static/pdf/manual-del-anuciante-mega.pdf" target="_blank"><img src="./icon-pdf.jpg" alt=""><span>DESCARGAR EL MANUAL</span></a>
            <a href="static/pdf/Mega_ManualDeEtica_Mayo2021 (1).pdf" target="_blank"><img src="./icon-pdf.jpg" alt=""><span>DESCARGAR EL CÓDIGO DE ÉTICA</span></a>
          </div>
        </div>
      </div>
    </section>  
    <pie></pie>
  </article>
</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
h5
  font-size: 30px
.btn-ar
    display: flex
    justify-content: center
    border: solid 1px #444
    margin-top: 30px
    width: 300px
    padding: 5px
    border-radius: 0px
    // &:hover
    // background-color: #004D9E
    &:hover
      background-color: #004D9E
      border-color: #fff
      a h5
        color: #fff
a h5
  font-size: 18px
  margin: 0
  display: inline-block
  color: black
  &:hover
    color: #fff
p
  padding-top: 15px
  padding-left: 10px
  padding-right: 10px
  text-align: center
  a
    color: #004D9E
i
  font-size: 16px
  opacity: 0.8
.caja
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  h5
    padding-top: 30px
  /* Global Styles */
.descripcion 
  margin: 0
  padding: 0
  p 
    margin: 40px 0
.secundario
  margin: 0
  padding: 0
  h4 
    margin: 40px 0 30px
    font-size: 20px
    font-weight: 500
  ul 
    padding-left: 20px
    margin: 0
    li 
      list-style: circle
      a
        color: #004d9e
.descargas
  padding: 40px 0
  a
    padding-right: 30px
    display: inline-block
    vertical-align: top
    color: #004d9e
    font-weight: 500
    font-size: 14px
    @media(max-width: 550px)
      display: block
      padding: 0
    img,
    span
      display: inline-block
      vertical-align: middle
    img 
      padding-right: 10px
</style>

<script>
export default {
  name: 'gobierno',
  components: {
    Cabecera,
    Pie
  }
}
import Cabecera from '@/components/Cabecera'
import Pie from '@/components/Pie'
import $ from 'jquery'
$(document).ready(function () {
  $('.btn').click(function () {
    $(this).toggleClass('active')
    $('.profile .box').toggleClass('open')
  })
})
</script>





// WEBPACK FOOTER //
// src/components/gobierno/gobierno.vue